import { useQuery } from 'react-query';
import type { QueryOptions } from 'react-query';

import type {
  GetMciReportDownloadUrlQuery,
  GetMciReportsQuery,
  MciReport,
} from '@portal/api-models';
import { getMostRecentMciReports } from '@portal/common';

import { client } from '../client';
import { QueryKey } from '../types';

export const getMciOffersReports = async (params?: GetMciReportsQuery) =>
  client
    .get<MciReport[]>('analytics/mci-reports/offers-reports', { params })
    .then(({ data }) => data);

export const getMciConversionsReports = async (params?: GetMciReportsQuery) =>
  client
    .get<MciReport[]>('analytics/mci-reports/conversions-reports', { params })
    .then(({ data }) => data);

export const getMciRejectionsReports = async (params?: GetMciReportsQuery) =>
  client
    .get<MciReport[]>('analytics/mci-reports/rejections-reports', { params })
    .then(({ data }) => data);

export const getMciReportDownloadUrl = async (
  params: GetMciReportDownloadUrlQuery
) =>
  client
    .get<string>('analytics/mci-reports/download-url', { params })
    .then(({ data }) => data);

export const useGetMciOffersReportsQuery = (params?: GetMciReportsQuery) =>
  useQuery([QueryKey.MciOffersReports, params], async () =>
    getMciOffersReports(params)
  );

export const useGetMciConversionsReportsQuery = (params?: GetMciReportsQuery) =>
  useQuery([QueryKey.MciConversionsReports, params], async () =>
    getMciConversionsReports(params)
  );

export const useGetMciRejectionsReportsQuery = (params?: GetMciReportsQuery) =>
  useQuery([QueryKey.MciRejectionsReports, params], async () =>
    getMciRejectionsReports(params)
  );

export const useGetMostRecentMciOffersReportsQuery = (
  options?: QueryOptions<MciReport[]>
) =>
  useQuery(
    [QueryKey.MciOffersReportsMostRecent],
    async () => getMciOffersReports().then(getMostRecentMciReports),
    options
  );

export const useGetMostRecentMciConversionsQuery = (
  options?: QueryOptions<MciReport[]>
) =>
  useQuery(
    [QueryKey.MciConversionsReportsMostRecent],
    async () => getMciConversionsReports().then(getMostRecentMciReports),
    options
  );

export const useGetMostRecentMciRejectionsReportsQuery = (
  options?: QueryOptions<MciReport[]>
) =>
  useQuery(
    [QueryKey.MciRejectionsReportsMostRecent],
    async () => getMciRejectionsReports().then(getMostRecentMciReports),
    options
  );
